var ValueJS = ValueJS || {};

ValueJS.ProductCard = function() {

    var _initialized = false;

    var _selectors = {
        productCard : '.product-card',
        mediaWrapper : '.product-card .product__media-wrapper',
        primaryMedia : 'product-card .product__media--primary',
        secondaryMedia : 'product-card .product__media--secondary',
    }

    var _init = function() {
        // image hover
        _initImageOnHover();

        if (!_initialized) {
            // _handleShopifyDesignModeEvents();
            _initialized = true;
        }
    }

    var _initImageOnHover = function() {
        $(_selectors.mediaWrapper).each(function() {
            let wrapper = $(this);
            
            wrapper.on('touchstart', function() {
                wrapper.addClass('hover');
            });

            wrapper.on('touchend', function() {
                wrapper.removeClass('hover');
            });

        });
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
    };

}();

$(function() {
    ValueJS.ProductCard.init();
});
